(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rf-hero-carousel')) {
  customElements.define('rf-hero-carousel',class extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.slides=[...this.querySelectorAll('.rf-hero__slide')];this.index=0;
      if(this.slides.length<2)return;
      this.controls=this.querySelector('.rf-carousel-controls');this.controls.hidden=false;
      this.toggle=this.querySelector('[data-toggle]');this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.reducedMotion.matches||this.hasAttribute('data-design-mode');
      this.visible=true;this.hovering=false;
      this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1,true),{signal});
      this.querySelector('[data-previous]').addEventListener('click',()=>this.go(this.index-1,true),{signal});
      this.querySelectorAll('[data-slide-index]').forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.slideIndex),true),{signal}));
      this.toggle.addEventListener('pointerdown',()=>{this.toggleIntent=!this.paused;},{signal});
      this.toggle.addEventListener('click',()=>{this.paused=typeof this.toggleIntent==='boolean'?this.toggleIntent:!this.paused;this.toggleIntent=undefined;this.sync();},{signal});
      this.addEventListener('focusin',()=>{this.paused=true;this.sync();},{signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovering=true;this.sync();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovering=false;this.sync();},{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});
      this.reducedMotion.addEventListener('change',()=>{if(this.reducedMotion.matches)this.paused=true;this.sync();},{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);
      document.addEventListener('shopify:block:select',event=>{
        const slide=event.target.closest('.rf-hero__slide');
        if(slide&&this.contains(slide))this.go(this.slides.indexOf(slide),true);
      },{signal});
      this.sync();
    }
    go(index,manual=false){
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index));});
      this.querySelectorAll('[data-slide-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));
      this.querySelector('[data-current-slide]').textContent=String(this.index+1);
      if(manual){this.paused=true;this.querySelector('[data-carousel-status]').textContent=this.dataset.positionLabel.replace('[current]',String(this.index+1)).replace('[total]',String(this.slides.length));}
      this.sync();
    }
    sync(){
      clearInterval(this.timer);
      if(!this.toggle)return;
      this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;
      const running=!this.paused&&!this.hovering&&this.visible&&!document.hidden;
      this.querySelector('.rf-hero__slides').setAttribute('aria-live','off');
      if(running)this.timer=setInterval(()=>this.go(this.index+1),Math.max(5000,Number(this.dataset.interval)||7000));
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-team"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rf-team-roster')) {
  customElements.define('rf-team-roster', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.groups = [...this.querySelectorAll('[data-roster-group]')].filter(group => group.querySelector('[data-person]'));
      const filters = this.querySelector('[data-roster-filters]');
      filters.replaceChildren();
      if (!this.groups.length) return;
      const options = [{id:'all',label:this.dataset.allLabel,count:this.groups.reduce((count,group)=>count+group.querySelectorAll('[data-person]').length,0)},...this.groups.map(group=>({id:group.id,label:group.dataset.rosterLabel,count:group.querySelectorAll('[data-person]').length}))];
      options.forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';button.className = 'rf-team__filter';button.dataset.filter = option.id;
        button.append(document.createTextNode(option.label));
        const count = document.createElement('span');count.textContent = String(option.count);count.setAttribute('aria-hidden','true');button.append(count);
        button.setAttribute('aria-controls',option.id==='all'?this.groups.map(group=>group.id).join(' '):option.id);
        button.addEventListener('click',()=>this.showGroup(option.id,true),{signal});
        filters.append(button);
      });
      filters.hidden = this.groups.length<2;
      this.showGroup(this.dataset.defaultFilter==='all'?'all':this.groups[0].id,false);
      document.addEventListener('shopify:block:select',event=>{
        if (!this.contains(event.target)) return;
        const group = event.target.closest('[data-roster-group]') || event.target.querySelector('[data-roster-group]');
        if(group) this.showGroup(group.id,false);
      },{signal});
    }
    showGroup(id,announce) {
      const chosen = this.groups.find(group=>group.id===id);
      if (id!=='all'&&!chosen) return;
      let visibleCount=0;
      this.groups.forEach(group=>{
        const visible=id==='all'||group.id===id;
        group.hidden=!visible;
        const wrapper=group.parentElement;
        if(wrapper.classList.contains('shopify-block')) wrapper.hidden=!visible;
        if(visible) visibleCount+=group.querySelectorAll('[data-person]').length;
      });
      this.querySelectorAll('[data-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===id)));
      if(announce){const label=chosen?.dataset.rosterLabel||this.dataset.allLabel;this.querySelector('[data-roster-status]').textContent=this.dataset.groupCount.replace('[group]',label).replace('[count]',String(visibleCount));}
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
